import { TenantTsType } from "@skygroup/shared/constants/tenantTs";

/**
 * Suppliers with ts_type === 1 (local inventory) should appear first in the
 * combined results list. Flights arrive in chunks (one ts_type per SSE
 * message), so priority chunks are prepended to the top of the list while all
 * other chunks are appended to the bottom.
 */
export const isPriorityTsType = (ts_type?: string | number): boolean =>
  ts_type ===  TenantTsType.SKY;

/**
 * Merges a newly received chunk of flights into the combined list, placing
 * priority (ts_type === 1) flights at the top and all others at the bottom.
 * Mutates `existingFlights` in place (safe to use inside Redux Toolkit/immer
 * reducers).
 */
export const mergeFlightsByTsTypePriority = (
  existingFlights: any[],
  newFlights: any[],
  ts_type?: string | number
): void => {
  if (isPriorityTsType(ts_type)) {
    existingFlights.unshift(...newFlights);
  } else {
    existingFlights.push(...newFlights);
  }
};
